import { Container, Typography } from "@mui/material";

export const DataDeletion = () => {
  return (
    <Container>
      <Typography variant="h4" textAlign="center">
        <b>Data Deletion Instructions</b>
      </Typography>
      <br />
      <br />
      <Typography>
        We understand that you may want to delete your personal data from our
        records. Please follow the instructions below to ensure that your data
        is deleted in a timely and secure manner.
      </Typography>
      <br />
      <Typography>
        <b>Step 1: Identify the data you want to delete</b>
      </Typography>
      <br />
      <Typography>
        Before starting the deletion process, you should identify the specific
        data you want to delete. This may include personal information such as
        your name, address, email address, phone number, and any other
        identifying information.
      </Typography>
      <br />
      <Typography>
        <b>Step 2: Backup important data</b>
      </Typography>
      <br />
      <Typography>
        If you have any important data that you want to keep, make sure you
        backup this information before starting the deletion process. Once your
        data is deleted, it cannot be retrieved.
      </Typography>
      <br />
      <Typography>
        <b>Step 3: Submit a deletion request</b>
      </Typography>
      <br />
      <Typography>
        To request deletion of your data, please contact our support team by
        email or phone. Provide your full name and any other identifying
        information necessary to locate your data in our records.
      </Typography>
      <br />
      <Typography>
        <b>Step 4: Confirm deletion</b>
      </Typography>
      <br />
      <Typography>
        Once we receive your deletion request, we will confirm that the data has
        been deleted from our records. Please note that it may take some time to
        delete all of your data from our systems.
      </Typography>
      <br />
      <Typography>
        <b>Step 5: Follow up</b>
      </Typography>
      <br />
      <Typography>
        If you have any questions or concerns about the deletion process, please
        don't hesitate to contact our support team. We are committed to
        protecting your privacy and ensuring that your data is deleted in a
        timely and secure manner.
      </Typography>
      <br />
      <br />
      <Typography>
        Thank you for trusting us with your personal data. We appreciate your
        business and are committed to protecting your privacy.
      </Typography>
      <br />
      <br />
    </Container>
  );
};
